import type { ComponentProps } from "react"

export default function IndustryQ(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M26.6666 9.33333H21.3333V5.33333C21.3333 4.97971 21.1928 4.64057 20.9428 4.39052C20.6927 4.14048 20.3536 4 20 4H12C11.6463 4 11.3072 4.14048 11.0571 4.39052C10.8071 4.64057 10.6666 4.97971 10.6666 5.33333V9.33333H5.33329C4.62605 9.33333 3.94777 9.61428 3.44767 10.1144C2.94758 10.6145 2.66663 11.2928 2.66663 12V25.3333C2.66663 26.0406 2.94758 26.7189 3.44767 27.219C3.94777 27.719 4.62605 28 5.33329 28H26.6666C27.3739 28 28.0521 27.719 28.5522 27.219C29.0523 26.7189 29.3333 26.0406 29.3333 25.3333V12C29.3333 11.2928 29.0523 10.6145 28.5522 10.1144C28.0521 9.61428 27.3739 9.33333 26.6666 9.33333ZM13.3333 6.66667H18.6666V9.33333H13.3333V6.66667ZM21.3333 20H17.3333V24H14.6666V20H10.6666V17.3333H14.6666V13.3333H17.3333V17.3333H21.3333V20Z"
        fill={fill}
      />
    </svg>
  )
}
